import { notification } from 'antd';
import helpers from '../../../apis/helpers';

const getSavedFilterView = async ({ payload }) => {
  const { query, url } = payload;

  const queryString = helpers.convertObjectToQueryString(query);
  const urlString = `${url}?${queryString}`;

  const response = await helpers.get({ url: urlString });

  return response;
};

const addSavedFilterView = async ({ payload, callback }) => {
  const { body, url } = payload;

  const response = await helpers.post({ url, data: body });
  if (response && response.success) {
    notification.success({
      message: 'Filter view saved successfully',
      duration: 4,
      placement: 'top',
    });
  }
  callback(response.data);
};

const updateSavedFilterView = async ({ payload, callback }) => {
  const { body, url } = payload;

  const response = await helpers.put({ url, data: body });

  if (response && response.success) {
    notification.success({
      message: 'Filter view updated successfully',
      duration: 4,
      placement: 'top',
    });
  }
  callback(response.data);
};

const deleteSavedFilterView = async ({ payload, callback }) => {
  const { body, url } = payload;

  const response = await helpers.delete({ url, data: body });

  if (response && response.success) {
    notification.success({
      message: 'Filter view deleted successfully',
      duration: 4,
      placement: 'top',
    });
  }
  callback(response.data);
};

const markOrRemoveDefaultSavedFilterView = async ({ payload, callback }) => {
  const { body, url } = payload;

  const response = await helpers.put({ url, data: body });

  if (response && response.success) {
    notification.success({
      message: 'Filter view updated successfully',
      duration: 4,
      placement: 'top',
    });
  }
  callback(response.data);
};

export {
  getSavedFilterView, addSavedFilterView, updateSavedFilterView, deleteSavedFilterView, markOrRemoveDefaultSavedFilterView,
};
